// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import arTranslations from './locales/ar.json';

i18n.use(initReactI18next).init({
  resources: {
    english: {
      translation: enTranslations,
    },
    fr: {
      translation: frTranslations,
    },
    ar: {
      translation: arTranslations,
    },
  },
  lng: 'fr', // Default language
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;